export const fauxCreate = (oldArray, newArray) => {
  return oldArray.concat(newArray)
}

export const fauxUpdate = (oldArray, newArray, uuid) => {
  let index = oldArray.findIndex(x => x.id === uuid)
  return oldArray.slice(0, index).concat(newArray).concat(oldArray.slice(index + 1))
}

export const fauxDelete = (oldArray, uuid) => {
  return oldArray.filter(x => x.id !== uuid)
}



// WEBPACK FOOTER //
// ./src/Utils/FauxArrayUtils.js